<div [ngClass]="{ 'color-bars': true, 'color-bars-rounded': rounded }">
  <app-mitre-color-bar *ngFor="let fillColor of colors" [fillColor]="fillColor" [height]="height"></app-mitre-color-bar>
</div>
